export interface ProductItem {
  id: string;
  name: string;
  category: string;
  subcategory: string;
  application: string;
  material: string;
  hardness: string;
  tempRange: string;
  features: string[];
  description: string;
  image: string;
  drawingAvailable: boolean;
}

export const productCategories = [
  "전체",
  "산업용 고무부품",
  "자동차용 고무부품",
  "패킹 및 가스켓",
  "고무 금형 제품",
];

export const allProducts: ProductItem[] = [
  {
    id: "industrial-oring-001",
    name: "산업용 O-Ring",
    category: "산업용 고무부품",
    subcategory: "오링/씰",
    application: "펌프 · 밸브 · 열교환기 · 실링장치",
    material: "NBR, EPDM, SILICONE, FKM",
    hardness: "70 ± 5 Shore A",
    tempRange: "-50℃ ~ +200℃",
    features: [
      "KS M 6518 규격 대응, 치수 공차 ±0.1mm 이내",
      "우수한 내열·내후성으로 장기 사용 가능",
      "다양한 소재로 화학·온도 환경별 최적 선택",
      "소량 100개부터 양산 가능, 금형비 별도",
    ],
    description:
      "펌프·밸브·열교환기 등 산업 설비의 핵심 실링 부품으로, NBR·EPDM·SILICONE·FKM 등 다양한 소재를 보유하고 있어 적용 환경에 맞는 최적의 O-Ring을 공급합니다. 50년간 축적된 정밀 성형 기술력으로 치수 공차를 엄격히 관리하며, 고객 특수 사양에 맞춘 맞춤 제작이 가능합니다.",
    image:
      "https://public.readdy.ai/ai/img_res/edited_fedf7555450ccb7ed00b0b4fb8efc2ed_939bc09e.jpg",
    drawingAvailable: true,
  },
  {
    id: "industrial-diaphragm-002",
    name: "산업용 다이아프램",
    category: "산업용 고무부품",
    subcategory: "다이아프램",
    application: "화학플랜트 · 반도체 · 제약설비 · 펌프",
    material: "NBR, EPDM",
    hardness: "75 ± 5 Shore A",
    tempRange: "-20℃ ~ +250℃",
    features: [
      "극한 화학환경에서 최고 수준의 내후성 발휘",
      "250℃ 고온에서도 탄성 유지, 장기 내구성 우수",
      "진공 환경 아웃가싱 최소화로 반도체 공정 적합",
      "맞춤 형상 설계로 기존 부품 대체 가능",
    ],
    description:
      "펌프·밸브·조절기 등에서 압력이나 유체를 제어하는 핵심 부품인 다이아프램입니다. NBR 및 EPDM 소재의 우수한 탄성과 내후성을 바탕으로, 화학 플랜트와 반도체·제약 설비 등 고신뢰성이 요구되는 분야에서 안정적인 성능을 발휘합니다. 고객 기존 부품을 샘플로 역설계하여 완벽하게 대체 제작 가능합니다.",
    image:
      "https://public.readdy.ai/ai/img_res/edited_d890bbcc9ea4eb0f6c7de6d54bb2116b_470c947f.jpg",
    drawingAvailable: true,
  },
  {
    id: "gasket-heat-ex-007",
    name: "열교환기용 가스켓",
    category: "패킹 및 가스켓",
    subcategory: "가스켓",
    application: "열교환기 · 발전플랜트 · 화학설비",
    material: "EPDM, NBR",
    hardness: "70 ± 5 Shore A",
    tempRange: "-50℃ ~ +150℃",
    features: [
      "Plate Heat Exchanger 전용 정밀 가스켓",
      "고온·고압 환경에서 탁월한 실링 성능",
      "Alfa Laval, GEA 등 주요 제조사 호환 가능",
      "식품 등급(FDA) EPDM 옵션 제공",
    ],
    description:
      "판형 열교환기(PHE) 전용 고성능 가스켓으로, EPDM 및 NBR 소재의 우수한 내열·내후성으로 장기간 안정적인 실링을 보장합니다. 주요 열교환기 제조사의 규격에 맞춰 정밀하게 제작되며, 식품·제약 산업용 FDA 등급 소재도 선택 가능합니다.",
    image:
      "https://public.readdy.ai/ai/img_res/edited_faa8145f0788d7e1d34e1eb094fcfaa4_4974e678.jpg",
    drawingAvailable: true,
  },
  {
    id: "auto-boots-004",
    name: "자동차용 고무 부츠 / 벨로우즈",
    category: "자동차용 고무부품",
    subcategory: "부츠/벨로우즈",
    application: "자동차 구동계 · 조향장치 · 서스펜션",
    material: "CR, NBR, EPDM",
    hardness: "60 ± 5 Shore A",
    tempRange: "-40℃ ~ +120℃",
    features: [
      "IATF 16949 인증 품질 시스템으로 생산",
      "주름 구조로 굴곡 및 왕복 운동에 유연하게 대응",
      "방진·방수·내마모성 우수로 장기 내구성 확보",
      "현대·기아 1차 협력사 납품 실적 다수",
    ],
    description:
      "자동차 구동계·조향장치·서스펜션 등에서 먼지와 이물질 침투를 차단하고 윤활유를 유지하는 고무 부츠 및 벨로우즈입니다. 주름 구조로 굴곡 운동에도 탁월한 유연성을 발휘하며, CR·NBR·EPDM 등 다양한 소재로 내후성·내마모성을 동시에 확보합니다. IATF 16949 인증 체계하에서 엄격한 품질 관리로 생산됩니다.",
    image:
      "https://public.readdy.ai/ai/img_res/edited_77aa2352dc62104b95f7338eb36bb29e_4696e11d.jpg",
    drawingAvailable: true,
  },
  {
    id: "silicone-valve-005",
    name: "실리콘 밸브 시트 / 링",
    category: "고무 금형 제품",
    subcategory: "실리콘 제품",
    application: "밸브 · 식품기계 · 의료기기 · 반도체",
    material: "VMQ (Silicone)",
    hardness: "50 ± 5 Shore A",
    tempRange: "-100℃ ~ +230℃",
    features: [
      "생체적합성 및 식품 등급(FDA) 확보",
      "투명·반투명·착색 성형 자유로움",
      "넓은 온도 범위에서 탄성 안정성 유지",
      "고무 금형 기술로 정밀 치수 구현",
    ],
    description:
      "밸브·식품기계·의료기기에 사용되는 고탄성 실리콘 고무 제품입니다. 생체적합성과 넓은 사용 온도 범위가 특징이며, 투명·반투명 및 다양한 색상의 성형이 가능합니다. 밸브 시트 및 실링 링 형태로 공급되며, 식품·제약·반도체 산업의 엄격한 품질 기준을 충족합니다.",
    image:
      "https://public.readdy.ai/ai/img_res/edited_2b5458d42347da3619363f71d295eb28_9b6d00e1.jpg",
    drawingAvailable: true,
  },
  {
    id: "precision-parts-006",
    name: "정밀 고무부품",
    category: "고무 금형 제품",
    subcategory: "정밀부품",
    application: "전자기기 · 하드디스크 · 계측장비 · 센서",
    material: "NBR, EPDM, VMQ",
    hardness: "40 ~ 70 Shore A",
    tempRange: "소재별 상이",
    features: [
      "마이크로 단위 정밀 금형으로 ±0.05mm 치수 공차 구현",
      "소형·초소형 부품 대량 생산 가능",
      "ISO 13485 의료기기 품질 기준 대응",
      "고객 도면 기반 맞춤 설계 및 개발 지원",
    ],
    description:
      "전자기기·하드디스크·계측장비에 사용되는 고정밀 고무 부품입니다. 마이크로 단위의 정밀 금형 기술로 초소형 부품도 안정적으로 생산하며, 전기적 절연성·내후성·내열성 등 요구 물성에 맞춰 NBR·EPDM·실리콘 등 최적의 소재를 선정합니다. 고객의 도면 및 샘플을 기반으로 역설계 및 맞춤 제작이 가능합니다.",
    image:
      "https://public.readdy.ai/ai/img_res/edited_88b23a10800e108a671e0c3c7f9b1093_957f8309.jpg",
    drawingAvailable: true,
  },
  {
    id: "custom-diaphragm-008",
    name: "맞춤형 다이아프램",
    category: "산업용 고무부품",
    subcategory: "다이아프램",
    application: "펌프 · 밸브 · 유압기기 · 화학설비",
    material: "NBR, EPDM, FKM, VMQ",
    hardness: "60 ~ 80 Shore A",
    tempRange: "-30℃ ~ +250℃",
    features: [
      "고객 도면/샘플 기반 완벽 역설계 맞춤 제작",
      "다양한 소재와 경도 옵션으로 환경별 최적화",
      "소형부터 대형까지 폭넓은 사이즈 대응",
      "소량 다품종 주문 유연한 생산 체계",
    ],
    description:
      "고객의 도면이나 샘플을 기반으로 맞춤 제작되는 산업용 다이아프램입니다. NBR, EPDM, FKM, VMQ 등 다양한 소재와 경도 옵션을 보유하고 있어 적용 환경에 최적화된 제품을 공급합니다. 소형 정밀 다이아프램부터 대형 산업용까지 폭넓은 사이즈에 대응 가능하며, 소량 다품종 주문에도 유연한 생산 체계를 갖추고 있습니다.",
    image:
      "https://public.readdy.ai/ai/img_res/edited_c5d69c3e49fd1eab2a364af12460f30c_d7b8a5a5.jpg",
    drawingAvailable: true,
  },
  {
    id: "food-grade-silicone-009",
    name: "식품공정 제품",
    category: "고무 금형 제품",
    subcategory: "실리콘 제품",
    application: "식품가공 · 제약설비 · 유제품 · 음료 생산",
    material: "VMQ (Silicone) FDA Grade",
    hardness: "50 ~ 70 Shore A",
    tempRange: "-60℃ ~ +230℃",
    features: [
      "FDA 및 식품위생법 적합 소재 사용",
      "무취·무독성으로 식품 직접 접촉 안전",
      "고온 살균(CIP/SIP) 공정에도 탄성 유지",
      "투명·반투명·컬러 맞춤 성형 가능",
    ],
    description:
      "식품 및 제약 공정에 특화된 고순도 실리콘 고무 제품입니다. FDA 등급 실리콘 소재를 사용하여 식품과 직접 접촉하는 환경에서도 안전하게 사용할 수 있으며, 고온 살균 공정에서도 우수한 내구성을 유지합니다. 실링 링, 가스켓, 패킹 등 다양한 형태로 공급되며, 투명·반투명 및 컬러 성형이 가능해 공정 구분용으로도 활용도가 높습니다.",
    image:
      "https://public.readdy.ai/ai/img_res/edited_13262d299019c08eabc0a634b928ca8c_51648965.jpg",
    drawingAvailable: true,
  },
  {
    id: "suction-cups-010",
    name: "흡착 컵",
    category: "고무 금형 제품",
    subcategory: "실리콘 제품",
    application: "물류자동화 · 포장기계 · 반도체 이송 · 진공장비",
    material: "VMQ (Silicone), NBR",
    hardness: "40 ~ 60 Shore A",
    tempRange: "-50℃ ~ +200℃",
    features: [
      "우수한 진공 유지력으로 안정적 물체 이송",
      "피흡착물 표면 손상 없는 소프트 터치 설계",
      "내마모성 우수로 반복 사용에도 형상 유지",
      "평판형·벨로우즈형·맞춤형 등 다양한 형상 제작",
    ],
    description:
      "물류 자동화·포장 기계·반도체 이송 공정에 사용되는 고탄성 실리콘 및 NBR 소재의 흡착 컵입니다. 우수한 진공 유지력과 소프트한 접촉면으로 다양한 형상의 물체를 안정적으로 이송하며, 반복적인 사용에도 내마모성이 뛰어나 장기간 형상을 유지합니다. 평판형, 벨로우즈형 등 용도에 맞춘 다양한 형상으로 제작 가능합니다.",
    image:
      "https://public.readdy.ai/ai/img_res/edited_b6fae09c1233c8bd44a39faaaf53f4db_75f543e6.jpg",
    drawingAvailable: true,
  },
];